export default "__VITE_ASSET__abd2ed64__"